export function entriesToObject<T extends string | number | symbol, P>(
  entries: IterableIterator<[T, P]>,
) {
  const result = {} as Record<T, P>;
  for (const [key, value] of entries) {
    result[key] = value;
  }
  return result;
}
